import React from 'react';
import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';

const LayerList = ({ layers, selectedLayerId, onSelectLayer, onMoveLayer, onRemoveLayer, onDuplicateLayer }) => {
    return (
        <List sx={{ width: '300px', bgcolor: 'background.paper' }}>
            {layers.map((layer, index) => (
                <ListItem key={layer.id} disablePadding>
                    <ListItemButton
                        selected={selectedLayerId === layer.id}
                        onClick={() => onSelectLayer(layer.id)}
                    >
                        <ListItemText primary={layer.type === 'image' ? `Image Layer ${index + 1}` : `Text Layer ${index + 1}`} />
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button onClick={() => onMoveLayer(layer.id, 'up')}>↑</button>
                            <button onClick={() => onMoveLayer(layer.id, 'down')}>↓</button>
                            <button onClick={() => onRemoveLayer(layer.id)}>X</button>
                            <button onClick={() => onDuplicateLayer(layer.id)}>Copy</button>
                        </div>
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
    );
};

export default LayerList;